(ns app.home-page.views
  (:require [app.components.buttons.views :as buttons]
            [app.components.headers.views :refer [header]]
            [app.components.icons.views :refer [outlook-icon mail-icon google-icon]]
            [app.login.events :as events]
            [app.routes :as routes]
            [app.events :as app-event]
            [app.home-page.styles :refer [app-bar home-page-container home-page-width home-page-title home-page-buttons bar-buttons home-page]]
            [re-com.core :as re-com :refer [at box h-box v-box]]
            [re-frame.core :as re-frame]))


(defn workspace-app-bar []

  [h-box
   :class (app-bar)
   :src   (at)
   :justify :between
   :children [[header {:label "Strive" :type :title :size :large :style {:color "white" :cursor "pointer"}}]
              [h-box
               :gap      "24px"
               :class (bar-buttons)
               :children [[box
                           :child [buttons/button {:action :cta
                                                   :type :secondary
                                                   :title "SIGN IN"
                                                   :size :large
                                                   :onClick #(re-frame/dispatch [::app-event/navigate [:login]])}]]
                          [box
                           :child [buttons/button {:action :cta :type :primary :title "SIGN UP" :size :large
                                                   :onClick #(re-frame/dispatch [::app-event/navigate [:sign-up]])}]]]]]])



(defn home-page-panel []
  [box :class (home-page) :child [v-box
                                  :src      (at)
                                  :height "100vh"
                                  :margin "auto"
                                  :class (home-page-width)
                                  :children [[workspace-app-bar]
                                             [v-box
                                              :src (at)
                                              :gap "18px"
                                              :class (home-page-container)
                                              :justify :center
                                              :align :center
                                              :children [[box :child [header  {:label "Where continuous improvement starts" :type :title :size :regular :style {:color "white"}}] :class (home-page-title)]
                                                         [box :child [header {:label "Strive is an all-in-one platform for forms, surveys, communications and reports."  :type :large :size :regular :style {:color "white"}}] :class (home-page-title)]
                                                         [box :child [:div]]
                                                         [h-box
                                                          :gap      "24px"
                                                          :class (home-page-buttons)
                                                          :children [[box
                                                                      :child [buttons/button {:action :cta
                                                                                              :type :secondary
                                                                                              :title "Sign Up With Microsoft"
                                                                                              :icon outlook-icon
                                                                                              :size :xlarge
                                                                                              :onClick #(re-frame/dispatch [::events/signInWithOutlookAuth])}]]
                                                                     [box
                                                                      :child [buttons/button {:action :cta
                                                                                              :type :secondary
                                                                                              :title "Sign Up With Google"
                                                                                              :icon google-icon
                                                                                              :size :xlarge
                                                                                              :onClick #(re-frame/dispatch [::events/signInWithGoogleAuth])}]]
                                                                     [box
                                                                      :child [buttons/button {:action :cta
                                                                                              :type :secondary
                                                                                              :title "Sign Up With Email"
                                                                                              :icon mail-icon
                                                                                              :size :xlarge
                                                                                              :onClick #(re-frame/dispatch [::app-event/navigate [:sign-up]])}]]]]]]]]])



(defmethod routes/panels :home-page-panel [] [home-page-panel])